

































































import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";

import {
    TransportLoad,
    TransportLoadTask
} from "@/models";

import taskStateColors from "../taskstates";

import PlanTaskDialogPartyAddress from "../components/PlanTaskDialogPartyAddress.vue";

@Component({
    components: {
        PlanTaskDialogPartyAddress
    }
})
export default class PlanTaskDialogLoadTask extends Vue {
    @Prop() value!: null | { load: TransportLoad; loadTask: TransportLoadTask };
    @Prop() hasBeenAdded!: boolean;
    @Prop() addedToOld!: boolean;

    taskStateColors = taskStateColors;
}
